export const defaultRowsPerPageOptions = [10, 25, 50];
